import React, { FunctionComponent } from 'react';
import { useQuery } from '@apollo/client';

import { MAGENTO_URL } from '@config/client.config';
import ExternalRedirect from '@app/routes/ExternalRedirect';
import CustomerCheckQuery from '@app/graphql/CustomerCheckQuery';
import { CustomerCheckQuery as CustomerCheckQueryResult } from '@app/graphql/__generated__/CustomerCheckQuery';

const CustomerCheck: FunctionComponent = ({ children }) => {
  const { data, error, loading } = useQuery<CustomerCheckQueryResult>(
    CustomerCheckQuery,
    { ssr: false }
  );
  const isInCohort = data?.user?.customer?.isInCohort ?? false;

  if (error || loading) {
    // Block rendering of the subtree until we have the customer props
    // Since the query is cached this will only happen on the first load
    return null;
  }

  // NOTE: If there's a data error, also just go back to the magento
  // checkout.
  if (!isInCohort) {
    return <ExternalRedirect to={`${MAGENTO_URL}/checkout`} />;
  }

  return <>{children}</>;
};

export default CustomerCheck;
